export default "__VITE_ASSET__B6eA3dod__"